import React from 'react';
import {Card, CardActionArea, CardMedia, Typography, Box} from '@mui/material';
import gambar2 from '../../other/image/image2.jpg';
import style from '../../css/TitleAnimate.module.css';
import {gsap} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function TitleAnimate(){
  React.useEffect(()=>{
    gsap.from('#aws',{opacity: 0, y:100, ease: "elastic", duration:1})
    gsap.from('#mp-q',{opacity: 0, y:100, ease: "elastic", delay:0.2, duration:1})
    gsap.from('#mu',{opacity: 0, y:100, ease: "elastic", delay:0.4, duration:1})
    gsap.from('#lt',{opacity: 0, y:100, ease: "elastic", delay:0.6, duration:1})
    gsap.from('#ha',{opacity: 0, y:100, ease: "elastic", delay:0.8, duration:1})
    gsap.from('#ht',{opacity: 0, y:100, ease: "elastic", delay:1, duration:1})
    gsap.from('#hp',{opacity: 0, y:100, ease: "elastic", delay:1.2, duration:1})
    gsap.from('#mpt',{opacity: 0, y:100, ease: "elastic", delay:1.4, duration:1})
  },[])

  return(
    <Card id='titleAnimateCon' elevation={6} className={style.card} square>
      <CardActionArea style={{backgroundColor:'black'}} className={style.CardContent}>
        <CardMedia
          image={gambar2}
          title={"gambar"}
          className={style.cardImage}
        />
        <Box alignItem= 'center' justifyContent= 'center' display='block' className={style.contain}>
          <Typography
            variant='h5'
            id='aws'
            style={{letterSpacing: '2vw',textAlign: 'center'}}>
            <span className={style.fontTitle}>Ahlan wa Sahlan</span>
          </Typography>
          <Typography
            variant='h5'
            id='mp-q'
            style={{textAlign: 'center'}}>
            <span className={style.fontTitle1} style={{color:'#b3ff66'}}>Mahasiswa Pecinta Qur`an</span>
          </Typography>
          <Typography
            variant='h5'
            id='mu'
            style={{textAlign: 'center'}}>
            <span className={style.fontTitle1} style={{color:'#ffff00'}}>Universitas Muhammadiyah Surakarta</span>
          </Typography>
          <Box id='lt' borderRadius={50} className={style.line}/>
          <Typography
            id='ha'
            variant='h6'
            style={{textAlign: 'center'}}>
            <span className={style.fontTitle2}>خَيْرُكُمْ مَنْ تَعَلَّمَ اْلقُرْآنَ وَعَلَّمَهُ</span>
          </Typography>
          <Typography
            variant='body1'
            id='ht'
            style={{textAlign: 'center'}}>
              <span className={style.fontTitle3}><i>"Sebaik-baik kalian adalah orang yang belajar Al-Qur`an dan mengamalkannya"</i></span>
          </Typography>
          <Typography
            variant='body1'
            id='hp'
            style={{textAlign: 'center',marginBottom:'50px'}}>
              <span className={style.fontTitle3}>(<b>H.R Bukhari</b>)</span>
          </Typography>
          <Typography
            id='mpt'
            variant='subtitle1'
            style={{textAlign:'center'}}>
              <span className={style.fontTitle4}><i>@Al-Qur`anismylifeAndwearefamily</i></span>
          </Typography>
        </Box>
      </CardActionArea>
    </Card>
  )
}
